<form [formGroup]="fileForm">
  <div class="bg-blue-2 d-flex al-center sp-between p-4">
    <div>
      <div>
        <span class="text-white fw-extrabold fs-4">Nuevo {{ data == 1 ? 'archivo':'enlace'}}</span>
      </div>
      <div>
        <span class="text-white fs-6 fw-regular">Ingresa el nombre del enlace y el {{ data == 1 ? 'archivo':'URL'}}</span>
      </div>
    </div>
    <div>
      <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
    </div>
  </div>
  <mat-dialog-content class="p-4 d-flex flex-column content-form gap">
    <div>
      <div class="mb-2">
        <span>Nombre</span>
      </div>
      <input type="text" formControlName="name" maxlength="50" [placeholder]="'Ingrese nombre del ' + (data == 1 ? 'archivo':'enlace')" class="w-100 border rounded px-3">
    </div>
    <ng-container *ngIf="data == 2">
      <div>
        <div class="mb-2">
          <span>URL</span>
        </div>
        <input type="text" formControlName="link" placeholder="Ingrese URL" class="w-100 border rounded px-3">
      </div>
    </ng-container>
    <ng-container *ngIf="data == 1">
      <div>
        <div class="mb-2">
          <span>Archivo</span>
        </div>
        <input type="text" formControlName="file" placeholder="Seleccione un archivo" class="w-100 border rounded px-3 pointer" (click)="file.click()" readonly>
        <input type="file" class="d-none" #file (change)="changeFile($event)" >
      </div>
    </ng-container>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button class="bg-blue-2 w-100" (click)="saveFileFolder()">
        <span class="fw-bold fs-5 text-white me-3">Guardar cambios</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>